import React, { useEffect, useState } from "react";
import { TbEdit, TbX } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { alertActions, appsettingActions } from "../../_actions";
import TabJson from "../../_helpers/TabJson.json";
import Loader from "../../components/Atoms/Loader";
import Nodata from "../../components/Atoms/NoData/NoData";
import { useLocation, useNavigate } from "react-router";

const FeesSetting = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const queryTab = queryParams.get("tab");
  const selector = useSelector((state) => state);
  const [activeTab, setActiveTab] = useState("EXPRESS_ADD_FUNDS");
  const [editableItem, setEditableItem] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    appsetting: { appFeeSettingList, loading },
  } = selector || {};

  useEffect(() => {
    if (activeTab) {
      dispatch(
        appsettingActions.getFeeSettings({
          setting: activeTab,
        })
      );
      setEditableItem(null);
    }
  }, [dispatch, activeTab]);

  const handleEditClick = (item) => {
    setEditableItem(item._id);
    setEditValue(item.value);
  };

  const handleUpdateValue = () => {
    if (!editableItem) return;

    setIsLoading(true);
    appsettingActions
      .updateFeeAppSetting({
        id: editableItem,
        value: editValue,
      })
      .then((res) => {
        if (res) {
          setIsLoading(false);
          dispatch(alertActions.success(res.message));
          dispatch(appsettingActions.getFeeSettings({ setting: activeTab }));
        }
      })
      .catch((error) => {
        dispatch(alertActions.error(error || "failed to edit !"));
      });
    setEditableItem(null);
  };

  useEffect(() => {
    if (queryTab) {
      navigate(`?tab=${queryTab}`, { replace: true });
      setActiveTab(queryTab);
    } else {
      navigate(`?tab=${"EXPRESS_ADD_FUNDS"}`, { replace: true });
      setActiveTab("EXPRESS_ADD_FUNDS");
    }
  }, [queryTab, navigate]);

  return (
    <div className="w-full p-6 mx-auto h-screen overflow-hidden overflow-y-auto">
      <Loader loading={loading || isLoading} />
      <h2 className="text-xl font-semibold mb-6 text-gray-800">Fees Setting</h2>

      <div className="border-b border-gray-200 mb-6">
        <nav className="grid xl:grid-cols-6 md:grid-cols-4 grid-cols-2 overflow-x-auto gap-2">
          {TabJson?.map((tab) => (
            <button
              key={tab.key}
              className={`whitespace-nowrap mr-6 py-2 ${
                activeTab === tab.key
                  ? "border-b-2 border-[#00811D] text-[#0F172A] font-medium"
                  : "text-gray-600 hover:text-gray-800"
              }`}
              onClick={() => {
                setActiveTab(tab.key);
                navigate(`?tab=${tab.key}`);
              }}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="bg-white">
        {appFeeSettingList?.loading ? (
          <div className="text-center py-4">Loading...</div>
        ) : appFeeSettingList?.error ? (
          <div className="text-center text-red-500 py-4">
            Error: {appFeeSettingList.error}
          </div>
        ) : (
          <div
            className={`grid grid-cols-1 ${
              appFeeSettingList?.data?.length % 2 !== 0
                ? "md:grid-cols-3"
                : "md:grid-cols-2"
            }`}
          >
            {appFeeSettingList && appFeeSettingList.data.length > 0 ? (
              appFeeSettingList.data.map((item) => (
                <div
                  key={item._id}
                  className="border-b border-r border-gray-200"
                >
                  <div className="flex justify-between items-center mb-2 bg-[#F1F5F9] p-3">
                    <span className="text-sm text-gray-700">{item.name}</span>
                    <button
                      className="text-gray-500 hover:text-blue-500"
                      onClick={
                        () =>
                          editableItem === item._id
                            ? setEditableItem(null) // close
                            : handleEditClick(item) // open edit
                      }
                    >
                      {editableItem === item._id ? (
                        <TbX size={22} title="Close" className="text-red-500" />
                      ) : (
                        <TbEdit
                          size={22}
                          title="Edit"
                          className="text-[#00811D]"
                        />
                      )}
                    </button>
                  </div>

                  <div className="p-4">
                    {editableItem === item._id ? (
                      <div className="flex items-center space-x-2">
                        <input
                          type="number"
                          value={editValue}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || value.length <= 10) {
                              setEditValue(value);
                            }
                          }}
                          className="w-full px-4 py-2 rounded-md border text-sm focus:outline-none bg-transparent appearance-none"
                        />
                        <button
                          onClick={handleUpdateValue}
                          disabled={!editValue.trim()}
                          className={`px-2 py-2 rounded text-sm ${
                            !editValue.trim()
                              ? "bg-gray-300 cursor-not-allowed"
                              : "bg-[#00811D] text-white"
                          }`}
                        >
                          Save
                        </button>
                      </div>
                    ) : (
                      <span className="text-sm">{item.value}</span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-2">
                <Nodata nodataLabel={`No Fee setting available`} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FeesSetting;
